"use strict";

import helpers from "./_helpers";

const Menu = () => {
    const init = () => {
        $(document).ready(function () {

            $('.js-navbar-toggle').on('click', function () {
                $(this).toggleClass('open');
                $('.js-header').toggleClass('menu-open');
                $('.js-header').removeClass('quote-open');
                $('.js-header-quote-form').removeClass('opened').find('.btn-text').text($('.js-header-button-container').attr('data-quote-button-text'));
            });

            $('.js-header-quote-form').on('click', function (e) {
                e.preventDefault();
                toggleQuoteForm('');
            });

            function toggleQuoteForm(force_direction) {
                $('.js-header').removeClass('menu-open');
                $('.js-navbar-toggle').removeClass('open');
                $('.js-dropdown-menu').removeClass('open child-open');
                $('.js-dropdown-toggle').removeClass('open');
                $('.js-header-close').removeClass('active');

                var direction = 'open';
                if($('.js-header-quote-form').hasClass('opened')) {
                    direction = 'close';
                }

                if(force_direction.length > 0) {
                    direction = force_direction;
                }

                if($('.js-header-quote-form-container').hasClass('js-anchor-link')) {
                    var $quote_form = $(document).find('#request-quote-form');

                    if($quote_form.length) {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $quote_form.offset().top - 100
                        }, 200);
                    }
                } else{
                    if(direction == 'close') {
                        $('.js-header').removeClass('quote-open');
                        $('.js-header-quote-form').removeClass('opened');
                        $('.js-header-quote-form').find('.btn-text').text($('.js-header-button-container').attr('data-quote-button-text'));
                    } else {
                        $('.js-header').addClass('quote-open');
                        $('.js-header-quote-form').addClass('opened');
                        $('.js-header-quote-form').find('.btn-text').text('').append('<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.4081 8.41559C25.189 7.6347 25.189 6.36655 24.4081 5.58566C23.6272 4.80478 22.359 4.80478 21.5782 5.58566L15 12.1701L8.41559 5.59191C7.6347 4.81103 6.36655 4.81103 5.58566 5.59191C4.80478 6.37279 4.80478 7.64095 5.58566 8.42183L12.1701 15L5.59191 21.5844C4.81103 22.3653 4.81103 23.6335 5.59191 24.4143C6.37279 25.1952 7.64095 25.1952 8.42183 24.4143L15 17.8299L21.5844 24.4081C22.3653 25.189 23.6335 25.189 24.4143 24.4081C25.1952 23.6272 25.1952 22.359 24.4143 21.5782L17.8299 15L24.4081 8.41559Z" fill="black"/></svg> Close');
                    }
                }
            }

            // On hover make white
            $('.js-header').on({
                mouseover: function () {
                    $(this).removeClass('white-header');
                },
                mouseleave: function () {
                    var scroll_top = $(window).scrollTop();

                    if(scroll_top <= 0) {
                        if(!$('.js-header').hasClass('menu-open') && !$('.js-header').hasClass('quote-open')) {
                            $(this).addClass('white-header');
                        }
                    }
                }
            });

            // detect scroll top or down
            // Reset scroll top so if it loads halfway down a page it doesnt assume its at the top
            var scroll_top = $(this).scrollTop();
            if(scroll_top > 0) {
                $('.js-header').removeClass('white-header');
            }

            var last_scroll_top = 0;
            $(window).on('scroll', function() {
                var scroll_top = $(this).scrollTop();

                // Caters for safari where the scroll top can be in the negative
                if(last_scroll_top < 0) {
                    last_scroll_top = 0;
                }

                if(scroll_top <= 0 && (!$('.js-header').hasClass('menu-open') && !$('.js-header').hasClass('quote-open'))) {
                    $('.js-header').addClass('white-header');
                } else {
                    $('.js-header').removeClass('white-header');
                }

                last_scroll_top = scroll_top;
            });

            $('.js-dropdown-toggle').on('click', function (e) {
                e.preventDefault();

                $('.js-header').removeClass('quote-open');
                $('.js-header-quote-form').removeClass('opened').find('.btn-text').text($('.js-header-button-container').attr('data-quote-button-text'));

                if(helpers.isMobileMenu()) {
                    $(this).parents('.js-dropdown-menu').animate({scrollTop: 0}, "fast");

                    if($(this).hasClass('open') || $(this).hasClass('menu-back')) {
                        $('.js-header').find('[data-menu-id="'+$(this).data('menu-id-toggle')+'"]').removeClass('open');
                        $('.js-header').find('[data-menu-id-toggle="'+$(this).data('menu-id-toggle')+'"]').removeClass('open');
                        $(this).parents('.js-dropdown-menu').removeClass('child-open');
                    } else {
                        $('.js-dropdown-toggle').removeClass('open');
                        $(this).addClass('open');
                        $('.js-header').addClass('menu-open').find('[data-menu-id="'+$(this).data('menu-id-toggle')+'"]').addClass('open');
                        $(this).parents('.js-dropdown-menu').addClass('child-open');
                    }
                } else {
                    if(!$(this).hasClass('open')) {
                        $('.js-dropdown-menu').removeClass('open');
                        $('.js-dropdown-toggle').removeClass('open');

                        $(this).addClass('open');
                        $('.js-header').addClass('menu-open').find('[data-menu-id="'+$(this).data('menu-id-toggle')+'"]').addClass('open');

                        $('.js-header-close').addClass('active');
                    } else {
                        $('.js-dropdown-menu').removeClass('open');
                        $('.js-dropdown-toggle').removeClass('open');

                        $(this).removeClass('open');
                        $('.js-header').removeClass('menu-open').find('[data-menu-id="'+$(this).data('menu-id-toggle')+'"]').removeClass('open');
                        $('.js-header-close').removeClass('active');
                    }
                }
            });

            $('.js-sub-menu-hover').on({
                mouseover: function () {
                    if(!helpers.isMobileMenu()) {
                        $(this).addClass('sub-menu-open');
                        $(this).find('.js-sub-menu-container').addClass('sub-menu-open').stop().slideDown(300);
                    }
                },
                mouseleave: function () {
                    if(!helpers.isMobileMenu()) {
                        $(this).removeClass('sub-menu-open');
                        $(this).find('.js-sub-menu-container').removeClass('sub-menu-open').stop().slideUp(300);
                    }
                }
            });

            $('.js-header-close').on('click', function () {
                $('.js-header').removeClass('menu-open').find('[data-menu-id="'+$(this).data('menu-id-toggle')+'"]').removeClass('open');
                toggleQuoteForm('close');
            });

            initSubMenus();

            $(window).on('resize',
                helpers.debounce(function(){
                    $('.js-sub-menu-container').attr('style', 'display:none;');
                    initSubMenus();
                })
            );
        });

        function initSubMenus() {
            $('.js-sub-menu-toggle').off('click');
            $('.js-sub-menu-toggle').on('click', function (e) {

                if(helpers.isMobileMenu()) {
                    if ($(this).parent().hasClass('sub-menu-open')) {
                        $(this).parent().removeClass('sub-menu-open');
                        $(this).parent().find('.js-sub-menu-container').removeClass('sub-menu-open').stop().slideUp(300);
                        return;
                    }

                   $(this).parent().parents('.navbar-nav').find('.js-sub-menu-hover').removeClass('sub-menu-open').find('.js-sub-menu-container').removeClass('sub-menu-open').slideUp();

                    e.preventDefault();
                    $(this).parent().addClass('sub-menu-open');
                    $(this).parent().find('.js-sub-menu-container').addClass('sub-menu-open').stop().slideDown(300);
                }
            });
        }
    };

    return {
        init: init
    };
};

export default Menu;